import Drawer from '@/components/Dashboard/common/Drawer';

import * as S from './styles';

export default {
    name: 'WithPanel',
    props: {
        renderPanel: {
            type: Boolean,
            default: false,
        },
        title: {
            type: Object | String,
            default() {
                return '';
            },
        },
        wrapStyle: {
            type: Object,
            default() {
                return {};
            },
        },
        editAreaPadding: {
            type: String,
            default: '20px 28px 0 28px',
        },
        closeOutside: {
            type: Boolean,
            default: true,
        },
        hasButtons: {
            type: Boolean,
            default: true,
        },
        closeBlockClasses: {
            type: Array,
            default() {
                return [];
            },
        },
        loadingMask: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    watch: {},
    computed: {},
    methods: {
        panelProps() {
            const {
                renderPanel,
                wrapStyle,
                editAreaPadding,
                closeOutside,
                hasButtons,
                closeBlockClasses,
                loadingMask,
            } = this;

            return {
                attrs: {
                    active: renderPanel,
                    wrapStyle,
                    editAreaPadding,
                    closeOutside,
                    hasButtons,
                    closeBlockClasses,
                    loadingMask,
                    onCancel: () => this.$emit('close'),
                    onConfirm: () => this.$emit('confirm'),
                    onClick: () => this.$emit('click'),
                },
            };
        },
    },
    render() {
        const { panelProps, title } = this;

        return (
            <Drawer {...panelProps()}>
                {this.$slots.header || (
                    <S.MainTitle slot="header">
                        <S.LeftWrapper>
                            <S.MainTitleTop>{title}</S.MainTitleTop>
                        </S.LeftWrapper>
                    </S.MainTitle>
                )}
                {this.$slots.default}
            </Drawer>
        );
    },
};
